import { render, staticRenderFns } from "./IncidentAlertVolume.vue?vue&type=template&id=10f5c162"
import script from "./IncidentAlertVolume.vue?vue&type=script&lang=js"
export * from "./IncidentAlertVolume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports